import { useTheme } from '@mui/material';

export const QuickStudyIcon = () => {
    const theme = useTheme();
    const { stroke } = theme.colors.other.icon;

    return (
        <svg width={49} height={48} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M29.55 8.39375C29.8375 8.1375 30.2062 8 30.5875 8C31.6625 8 32.4125 9.06875 32.05 10.0812L27.7938 22H34.6875C35.6187 22 36.375 22.7563 36.375 23.6875C36.375 24.175 36.1687 24.6312 35.8062 24.9562L19.1938 39.6125C18.9125 39.8625 18.5437 40 18.1625 40C17.0875 40 16.3375 38.9313 16.6937 37.9188L20.9563 26H13.9875C13.1 26 12.375 25.275 12.375 24.3875C12.375 23.925 12.575 23.4875 12.9188 23.1812L29.55 8.39375ZM29.5812 11.0438L15.0062 24H22.375C22.7 24 23.0063 24.1562 23.1938 24.425C23.3813 24.6937 23.425 25.0312 23.3188 25.3375L19.1625 36.975L33.8625 24H26.375C26.05 24 25.7437 23.8438 25.5562 23.575C25.3687 23.3062 25.325 22.9688 25.4312 22.6625L29.5812 11.0375V11.0438Z"
                fill={stroke.primary}
            />
        </svg>
    );
};
